const basePath = '/workflows';
const automationsPath = `${basePath}/automations`;
const approvalsPath = `${basePath}/approvals`;

export const automationsRoutes = {
  root: basePath,
  list: automationsPath,
  create: `${automationsPath}/new`,
  detail: `${automationsPath}/:id`,
  executionDetail: `${automationsPath}/:id/executions/:executionId`,
  approvals: approvalsPath,
} as const;
